import store from '@/store';
import { computed } from 'vue';
const useClock = () => {
    const now = computed(() => store.state.clock.now);
    const nowDate = computed(() => new Date(store.state.clock.now * 1000));
    return {
        now,
        nowDate
    };
};
export default useClock;
